// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import { DefaultHttpClient } from "@azure/core-http";
var _defaultHttpClient = new DefaultHttpClient();
export function getCachedDefaultHttpClient() {
    return _defaultHttpClient;
}
//# sourceMappingURL=cache.js.map